/**
 * Constants for Job Posting Page
 * Contains all static data, configurations, and constants
 */

export const FORM_STEPS = [
  { id: 1, title: 'Job Details', icon: 'Briefcase' },
  { id: 2, title: 'Requirements', icon: 'CheckSquare' },
  { id: 3, title: 'Compensation', icon: 'DollarSign' },
  { id: 4, title: 'Review & Publish', icon: 'Eye' }
];

export const EXPERIENCE_LEVELS = [
  { value: 'entry', label: 'Entry Level (0-2 years)' },
  { value: 'intermediate', label: 'Intermediate (2-5 years)' },
  { value: 'senior', label: 'Senior (5+ years)' },
  { value: 'expert', label: 'Expert (10+ years)' }
];

export const EMPLOYMENT_TYPES = [
  { value: 'full-time', label: 'Full-time' },
  { value: 'part-time', label: 'Part-time' },
  { value: 'contract', label: 'Contract' },
  { value: 'freelance', label: 'Freelance' }
];

export const REMOTE_OPTIONS = [
  { value: 'remote', label: 'Fully Remote' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'onsite', label: 'On-site' }
];

export const COMMON_BENEFITS = [
  'Health Insurance',
  'Paid Time Off',
  'Flexible Schedule',
  'Professional Development',
  'Remote Work',
  'Performance Bonuses',
  'Equipment Provided',
  'Training & Certification'
];

export const CURRENCIES = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'CAD', label: 'CAD' },
  { value: 'AUD', label: 'AUD' }
];

export const INITIAL_JOB_DATA = (companyName = '') => ({
  title: '',
  description: '',
  requirements: '',
  responsibilities: '',
  skills_required: [],
  experience_level: 'intermediate',
  employment_type: 'full-time',
  location: '',
  remote_work: 'hybrid',
  salary_min: '',
  salary_max: '',
  currency: 'USD',
  benefits: [],
  application_deadline: '',
  start_date: '',
  company_name: companyName,
  company_description: '',
  status: 'draft'
});

export const SKILL_CONSTRAINTS = {
  MIN_LENGTH: 2,
  MAX_LENGTH: 50,
  MIN_SKILLS: 1,
  MAX_SKILLS: 15
};

export const VALIDATION_PATTERNS = {
  SKILL: /^[a-zA-Z0-9\s\-\+\.\#&\/\(\)\,\'\"]+$/
};
